var _defineProperty = require("D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
module.exports = function (modules) {
  var installedModules = {};
  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }
  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js": function __node_modules_Babel_runtimeCorejs3_coreJs_object_definePropertyJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/define-property");
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js": function __node_modules_Babel_runtimeCorejs3_helpers_classCallCheckJs(module, exports) {
    module.exports = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js": function __node_modules_Babel_runtimeCorejs3_helpers_definePropertyJs(module, exports, __webpack_require__) {
    var _Object$defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");
    module.exports = function (obj, key, value) {
      return key in obj ? _Object$defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : obj[key] = value, obj;
    };
  },
  "./index.js": function _indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "HttpTransport", function () {
      return HttpTransport_HttpTransport;
    }), __webpack_require__.d(__webpack_exports__, "HttpRequest", function () {
      return HttpRequest_HttpRequest;
    }), __webpack_require__.d(__webpack_exports__, "HttpRequestBuilder", function () {
      return HttpRequestBuilder_HttpRequestBuilder;
    }), __webpack_require__.d(__webpack_exports__, "REQUEST_HANDLER_TYPE", function () {
      return REQUEST_HANDLER_TYPE;
    }), __webpack_require__.d(__webpack_exports__, "createJsonHttpRequest", function () {
      return createJsonHttpRequest;
    }), __webpack_require__.d(__webpack_exports__, "createHttpRequest", function () {
      return createHttpRequest;
    }), __webpack_require__.d(__webpack_exports__, "basicAuthOptions", function () {
      return basicAuthOptions;
    }), __webpack_require__.d(__webpack_exports__, "tokenAuthOptions", function () {
      return tokenAuthOptions;
    }), __webpack_require__.d(__webpack_exports__, "jsonOptions", function () {
      return jsonOptions;
    }), __webpack_require__.d(__webpack_exports__, "langLocaleOptions", function () {
      return langLocaleOptions;
    }), __webpack_require__.d(__webpack_exports__, "analyticsHandler", function () {
      return analyticsHandler;
    }), __webpack_require__.d(__webpack_exports__, "authTokenHandler", function () {
      return authTokenHandler;
    }), __webpack_require__.d(__webpack_exports__, "zipkinTraceHandler", function () {
      return zipkinTraceHandler;
    }), __webpack_require__.d(__webpack_exports__, "fastOptionsMerge", function () {
      return fastOptionsMerge;
    });
    var now_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/date/now"),
      now_default = __webpack_require__.n(now_),
      classCallCheck = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js"),
      classCallCheck_default = __webpack_require__.n(classCallCheck),
      defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js"),
      defineProperty_default = __webpack_require__.n(defineProperty),
      promise_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/promise"),
      promise_default = __webpack_require__.n(promise_);
    function fastOptionsMerge(defaults, overrides) {
      var headers = _objectSpread({}, null == defaults ? void 0 : defaults.headers, {}, null == overrides ? void 0 : overrides.headers);
      return _objectSpread({}, defaults, {}, overrides, {
        headers: headers
      });
    }
    function onResolvePromise(value) {
      return promise_default.a.resolve(value);
    }
    function onRejectPromise(value) {
      return promise_default.a.reject(value);
    }
    function defaultOnTrace() {}
    function defaultOnFetch(url, options) {
      var fetchCall = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fetch;
      return fetchCall(url, options);
    }
    var HttpTransport_HttpTransport = function HttpTransport(handlers) {
      var _this = this;
      classCallCheck_default()(this, HttpTransport), defineProperty_default()(this, "fetch", function _callee(url, method, opts) {
        var options, start, fetchWithTrace, response;
        return _regeneratorRuntime().async(function _callee$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              options = _objectSpread({}, opts, {
                method: method
              }), start = now_default()(), fetchWithTrace = function fetchWithTrace() {
                var fetchOptions, authOptions;
                return _regeneratorRuntime().async(function fetchWithTrace$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _this.onTrace("request", {
                        url: url,
                        options: options
                      });
                      fetchOptions = options;
                      if (!_this.onAuth) {
                        _context4.next = 7;
                        break;
                      }
                      _context4.next = 5;
                      return _regeneratorRuntime().awrap(_this.onAuth());
                    case 5:
                      authOptions = _context4.sent;
                      fetchOptions = fastOptionsMerge(options, authOptions);
                    case 7:
                      return _context4.abrupt("return", fetch(url, fetchOptions));
                    case 8:
                    case "end":
                      return _context4.stop();
                  }
                }, null, null, null, Promise);
              };
              _context5.prev = 1;
              _context5.next = 4;
              return _regeneratorRuntime().awrap(_this.onFetch(url, options, fetchWithTrace));
            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.ok ? (_this.onTrace("response", {
                url: url,
                options: options,
                response: response,
                duration: now_default()() - start
              }), _this.onResponse(response)) : (_this.onTrace("error", {
                url: url,
                options: options,
                error: response,
                duration: now_default()() - start
              }), _this.onErrorResponse(response)));
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);
              return _context5.abrupt("return", (_this.onTrace("exception", {
                url: url,
                options: options,
                exception: _context5.t0,
                duration: now_default()() - start
              }), _this.onException(_context5.t0)));
            case 11:
            case "end":
              return _context5.stop();
          }
        }, null, null, [[1, 8]], Promise);
      });
      var _ref = handlers || {},
        onAuth = _ref.onAuth,
        onErrorResponse = _ref.onErrorResponse,
        onException = _ref.onException,
        onFetch = _ref.onFetch,
        onResponse = _ref.onResponse,
        onTrace = _ref.onTrace;
      this.onAuth = onAuth, this.onErrorResponse = onErrorResponse || onRejectPromise, this.onException = onException || onRejectPromise, this.onFetch = onFetch || defaultOnFetch, this.onResponse = onResponse || onResolvePromise, this.onTrace = onTrace || defaultOnTrace;
    };
    var keys_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/keys"),
      keys_default = __webpack_require__.n(keys_),
      for_each_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/for-each"),
      for_each_default = __webpack_require__.n(for_each_),
      url_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/url"),
      url_default = __webpack_require__.n(url_),
      stringify_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/json/stringify"),
      stringify_default = __webpack_require__.n(stringify_),
      includes_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/includes"),
      includes_default = __webpack_require__.n(includes_);
    var defaultEncoder = function defaultEncoder(data, options) {
      return (null == options ? void 0 : options.headers) && (headers = options.headers)["Content-Type"] && includes_default()(_context = headers["Content-Type"]).call(_context, "application/json") ? stringify_default()(data) : data;
      var headers, _context;
    };
    function defaultResponseHandler(response) {
      if (204 === response.status) return promise_default.a.resolve(null);
      var contentType = response.headers.get("Content-Type");
      return contentType && includes_default()(contentType).call(contentType, "application/json") ? response.json() : contentType && includes_default()(contentType).call(contentType, "application/octet-stream") ? response.blob() : response.text();
    }
    function defaultErrorResponseHandler(response) {
      var message, error, contentType;
      return _regeneratorRuntime().async(function defaultErrorResponseHandler$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            error = {
              status: response.status,
              statusText: response.statusText || "<none>"
            }, contentType = response.headers.get("Content-Type");
            _context6.t0 = contentType;
            if (!_context6.t0) {
              _context6.next = 14;
              break;
            }
            if (!includes_default()(contentType).call(contentType, "application/json")) {
              _context6.next = 9;
              break;
            }
            _context6.next = 6;
            return _regeneratorRuntime().awrap(response.json());
          case 6:
            _context6.t1 = _context6.sent;
            _context6.next = 13;
            break;
          case 9:
            _context6.next = 11;
            return _regeneratorRuntime().awrap(response.text());
          case 11:
            _context6.t2 = _context6.sent;
            _context6.t1 = {
              message: _context6.t2
            };
          case 13:
            message = _context6.t1;
          case 14:
            return _context6.abrupt("return", promise_default.a.reject(_objectSpread({}, error, {}, message)));
          case 15:
          case "end":
            return _context6.stop();
        }
      }, null, null, null, Promise);
    }
    function defaultExceptionHandler(err) {
      return promise_default.a.reject(err.message);
    }
    function buildUrl(url, baseUrl) {
      return baseUrl ? new url_default.a(url, baseUrl).toString() : url;
    }
    var HttpRequest_HttpRequest = function HttpRequest(baseUrl, defaultOptions, handlerOverrides) {
      var _this2 = this;
      classCallCheck_default()(this, HttpRequest), defineProperty_default()(this, "get", function (url, params, optionOverrides) {
        var requestOptions = fastOptionsMerge(_this2.defaultOptions, optionOverrides),
          requestUrl = "".concat(buildUrl(url, _this2.baseUrl)).concat(function (params) {
            var _context;
            if (!params) return "";
            var fakeUrl = new url_default.a("http://www.gw.com");
            return for_each_default()(_context = keys_default()(params)).call(_context, function (key) {
              return fakeUrl.searchParams.append(key, params[key]);
            }), fakeUrl.search;
          }(params));
        return _this2.transport.fetch(requestUrl, "GET", requestOptions);
      }), defineProperty_default()(this, "post", function (url, data, optionOverrides) {
        return _this2.request(url, "POST", data, optionOverrides);
      }), defineProperty_default()(this, "put", function (url, data, optionOverrides) {
        return _this2.request(url, "PUT", data, optionOverrides);
      }), defineProperty_default()(this, "patch", function (url, data, optionOverrides) {
        return _this2.request(url, "PATCH", data, optionOverrides);
      }), defineProperty_default()(this, "delete", function (url, data, optionOverrides) {
        return _this2.request(url, "DELETE", data, optionOverrides);
      }), defineProperty_default()(this, "request", function (url, method, data, optionOverrides) {
        var onEncode = _this2.handlers.onEncode,
          requestOptions = fastOptionsMerge(_this2.defaultOptions, optionOverrides);
        return requestOptions.body = onEncode && data ? onEncode(data, requestOptions) : data, _this2.transport.fetch(buildUrl(url, _this2.baseUrl), method, requestOptions);
      }), this.baseUrl = baseUrl, this.defaultOptions = defaultOptions, this.handlers = _objectSpread({
        onEncode: defaultEncoder,
        onErrorResponse: defaultErrorResponseHandler,
        onException: defaultExceptionHandler,
        onResponse: defaultResponseHandler
      }, handlerOverrides), this.transport = new HttpTransport_HttpTransport(this.handlers);
    };
    var reduce_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/reduce"),
      reduce_default = __webpack_require__.n(reduce_),
      every_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/every"),
      every_default = __webpack_require__.n(every_),
      values_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/values"),
      values_default = __webpack_require__.n(values_),
      logger_ = __webpack_require__("@jutro/logger");
    var REQUEST_HANDLER_TYPE = {
        AUTH: "onAuth",
        FETCH: "onFetch",
        ENCODE: "onEncode",
        ERROR: "onErrorResponse",
        EXCEPTION: "onException",
        RESPONSE: "onResponse",
        TRACE: "onTrace"
      },
      REQUEST_HANDLER_TYPE_VALUES = values_default()(REQUEST_HANDLER_TYPE);
    var HttpRequestBuilder_HttpRequestBuilder = function HttpRequestBuilder() {
      var _this3 = this;
      var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      classCallCheck_default()(this, HttpRequestBuilder), defineProperty_default()(this, "addOptions", function (options) {
        return _this3.options || (_this3.options = []), _this3.options.push(options), _this3;
      }), defineProperty_default()(this, "addHandler", function (event, callback) {
        var _context;
        var handler = event;
        event && callback && (handler = _defineProperty({}, event, callback));
        return every_default()(_context = keys_default()(handler)).call(_context, function (eventKey) {
          return !!includes_default()(REQUEST_HANDLER_TYPE_VALUES).call(REQUEST_HANDLER_TYPE_VALUES, eventKey) || (logger_.log.warning("Invalid event type \"".concat(eventKey, "\" supplied to \"HttpRequestBuilder.addHandler()\"")), !1);
        }) ? (_this3.handlers || (_this3.handlers = []), _this3.handlers.push(handler), _this3) : _this3;
      }), defineProperty_default()(this, "build", function () {
        var _context2, _context3;
        var options = _this3.options && reduce_default()(_context2 = _this3.options).call(_context2, function (list, values) {
            return fastOptionsMerge(list, values);
          }),
          handlers = _this3.handlers && reduce_default()(_context3 = _this3.handlers).call(_context3, function (list, values) {
            return _objectSpread({}, list, {}, values);
          });
        return new HttpRequest_HttpRequest(_this3.baseUrl, options, handlers);
      }), this.baseUrl = baseUrl;
    };
    var locale_ = __webpack_require__("@jutro/locale"),
      events_ = __webpack_require__("@jutro/events");
    var eventTopicMap = {
        request: events_.JUTRO_TOPICS.FETCH_REQUEST,
        response: events_.JUTRO_TOPICS.FETCH_RESPONSE,
        error: events_.JUTRO_TOPICS.FETCH_ERROR,
        exception: events_.JUTRO_TOPICS.FETCH_ERROR
      },
      analyticsHandler = _defineProperty({}, REQUEST_HANDLER_TYPE.TRACE, function (event, payload) {
        Object(events_.publish)(eventTopicMap[event], payload);
      }),
      jsonOptions = {
        headers: {
          "Content-Type": "application/json; charset=UTF-8"
        }
      };
    function langLocaleOptions(language, locale) {
      return {
        headers: {
          "gw-language": language,
          "gw-locale": locale
        }
      };
    }
    function createHttpRequest(baseUrl) {
      var build = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var request = new HttpRequestBuilder_HttpRequestBuilder(baseUrl).addOptions(langLocaleOptions(locale_.LocaleService.getCurrentLanguage(), locale_.LocaleService.getCurrentLocale())).addHandler(analyticsHandler);
      return build ? request.build() : request;
    }
    function createJsonHttpRequest(baseUrl) {
      var build = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var request = createHttpRequest(baseUrl, !1).addOptions(jsonOptions);
      return build ? request.build() : request;
    }
    function basicAuthOptions(userName, password) {
      return {
        headers: {
          Authorization: "Basic " + btoa("".concat(userName || "", ":").concat(password || ""))
        }
      };
    }
    function tokenAuthOptions(accessToken) {
      if (Object(logger_.warning)("tokenAuthOptions is deprecated, please use `authTokenHandler` that support token refresh/timeout"), accessToken) return {
        headers: {
          Authorization: "Bearer " + accessToken
        }
      };
    }
    var auth_ = __webpack_require__("@jutro/auth");
    var authTokenHandler = _defineProperty({}, REQUEST_HANDLER_TYPE.AUTH, function _callee2() {
      var accessToken;
      return _regeneratorRuntime().async(function _callee2$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _regeneratorRuntime().awrap(Object(auth_.getAccessToken)());
          case 2:
            accessToken = _context7.sent;
            return _context7.abrupt("return", {
              headers: {
                Authorization: "Bearer " + accessToken,
                "GW-Tenant": Object(auth_.decodeJWTTokenPayload)(accessToken).tenant_id
              }
            });
          case 4:
          case "end":
            return _context7.stop();
        }
      }, null, null, null, Promise);
    });
    var external_zipkin_ = __webpack_require__("zipkin"),
      external_zipkin_instrumentation_fetch_ = __webpack_require__("zipkin-instrumentation-fetch"),
      external_zipkin_instrumentation_fetch_default = __webpack_require__.n(external_zipkin_instrumentation_fetch_),
      external_zipkin_transport_http_ = __webpack_require__("zipkin-transport-http"),
      config_ = __webpack_require__("@jutro/config");
    var JSON_V2 = external_zipkin_.jsonEncoder.JSON_V2;
    function zipkinTraceHandler(remoteServiceName, localServiceName, zipkinUrl, debug) {
      var fetchCall = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : fetch;
      var recorder;
      var zipkinDebugConfigValue = Object(config_.getConfigValue)("zipkinDebug"),
        zipkinUrlConfigValue = Object(config_.getConfigValue)("zipkinUrl");
      recorder = debug || zipkinDebugConfigValue ? new external_zipkin_.ConsoleRecorder() : zipkinUrl || zipkinUrlConfigValue ? new external_zipkin_.BatchRecorder({
        logger: new external_zipkin_transport_http_.HttpLogger({
          endpoint: zipkinUrl || zipkinUrlConfigValue,
          jsonEncoder: JSON_V2,
          fetch: fetch
        })
      }) : {
        record: function record() {},
        toString: function toString() {
          return "nullTracer";
        }
      };
      var tracer = new external_zipkin_.Tracer({
        ctxImpl: new external_zipkin_.ExplicitContext(),
        recorder: recorder,
        localServiceName: localServiceName || Object(config_.getConfigValue)("zipkinLocalServiceName")
      });
      return _defineProperty({}, REQUEST_HANDLER_TYPE.FETCH, function (url, options) {
        var theFetch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fetchCall;
        return external_zipkin_instrumentation_fetch_default()(theFetch, {
          tracer: tracer,
          remoteServiceName: remoteServiceName || Object(config_.getConfigValue)("zipkinRemoteServiceName")
        })(url, options);
      });
    }
  },
  "@babel/runtime-corejs3/core-js-stable/date/now": function babel_runtimeCorejs3_coreJsStable_date_now(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/date/now");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/every": function babel_runtimeCorejs3_coreJsStable_instance_every(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/every");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/for-each": function babel_runtimeCorejs3_coreJsStable_instance_forEach(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/includes": function babel_runtimeCorejs3_coreJsStable_instance_includes(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/includes");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/reduce": function babel_runtimeCorejs3_coreJsStable_instance_reduce(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/reduce");
  },
  "@babel/runtime-corejs3/core-js-stable/json/stringify": function babel_runtimeCorejs3_coreJsStable_json_stringify(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/json/stringify");
  },
  "@babel/runtime-corejs3/core-js-stable/object/keys": function babel_runtimeCorejs3_coreJsStable_object_keys(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/keys");
  },
  "@babel/runtime-corejs3/core-js-stable/object/values": function babel_runtimeCorejs3_coreJsStable_object_values(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/values");
  },
  "@babel/runtime-corejs3/core-js-stable/promise": function babel_runtimeCorejs3_coreJsStable_promise(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/promise");
  },
  "@babel/runtime-corejs3/core-js-stable/url": function babel_runtimeCorejs3_coreJsStable_url(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/url");
  },
  "@jutro/auth": function jutro_auth(module, exports) {
    module.exports = require("@jutro/auth");
  },
  "@jutro/config": function jutro_config(module, exports) {
    module.exports = require("@jutro/config");
  },
  "@jutro/events": function jutro_events(module, exports) {
    module.exports = require("@jutro/events");
  },
  "@jutro/locale": function jutro_locale(module, exports) {
    module.exports = require("@jutro/locale");
  },
  "@jutro/logger": function jutro_logger(module, exports) {
    module.exports = require("@jutro/logger");
  },
  "core-js-pure/features/object/define-property": function coreJsPure_features_object_defineProperty(module, exports) {
    module.exports = require("core-js-pure/features/object/define-property");
  },
  zipkin: function zipkin(module, exports) {
    module.exports = require("zipkin");
  },
  "zipkin-instrumentation-fetch": function zipkinInstrumentationFetch(module, exports) {
    module.exports = require("zipkin-instrumentation-fetch");
  },
  "zipkin-transport-http": function zipkinTransportHttp(module, exports) {
    module.exports = require("zipkin-transport-http");
  }
});